<template>
    <c-contract-editor
        title      = "Wartungsvertrag"
        :unit-data = "unitData"
        @store     = "onStore"
        @edit      = "onEdit"
        @start     = "onStart"
        @end       = "onEnd"
    >
        <template v-slot:additional>
            <v-row class="no-frame">
                <v-col class="no-frame pr-2 col-6">
                    <f-currency-field-rw
                        class     = "money"
                        :label    = "$t('contract.mnt.costsPerYear')"
                        :readonly = "readonly"
                        v-model   = "unitData.costs"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col class="no-frame pl-2 col-6">
                    <f-number-field-rw
                        :label         = "$t('contract.mnt.countPerYear')"
                        v-model        = "unitData.count"
                        :readonly      = "readonly"
                        :hide-details = "true"
                    />
                </v-col>
            </v-row>
        </template>
    </c-contract-editor>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import Contract         from "@/modules/msd/company/contract/service/Contract";
import CContractEditor  from "@/modules/msd/company/contract/components/controls/CContractEditor.vue";
import FCurrencyFieldRw from "@/modules/core/components/utils/FCurrencyFieldRw.vue";
import FNumberFieldRw   from "@/modules/core/components/utils/FNumberFieldRw.vue";

export default {
    name: "CContractMntEditor",

    components: {
        FNumberFieldRw,
        FCurrencyFieldRw,
        CContractEditor,
    },

    props: {
        unit: {
            default: function () {
                return {
                    contractMntStart: null,
                    contractMntCostsPerYear: null,
                    contractMntCountPerYear: null,
                }
            }
        }
    },

    data: () => ({
        readonly: true,
        unitData: {
            start: null,
            costs: null,
            count: null,
        }
    }),

    mounted() {
        this.setData();
    },

    watch: {
        unit () {
            this.setData();
        }
    },

    methods: {
        onStore () {
            Contract.unit.saveMnt(this.unit.id, this.unit.contractMntId, this.unitData).then(() => {
                this.unit.contractMntStart = this.unitData.start;
                this.unit.contractMntExpiration = this.unitData.end;
                this.unit.contractMntCostsPerYear = this.unitData.costs;
                this.unit.contractMntCountPerYear = this.unitData.count;
                Core.message.hint(this, this.$t('contract.edit.stored'));
            })
        },

        onEdit (readonly) {
            this.readonly = readonly;
        },

        onStart (value) {
            this.unitData.start = value;
        },

        onEnd (value) {
            this.unitData.end = value;
        },

        setData () {
            this.unitData.start = this.unit.contractMntStart;
            this.unitData.end   = this.unit.contractMntExpiration;
            this.unitData.costs = this.unit.contractMntCostsPerYear;
            this.unitData.count = this.unit.contractMntCountPerYear;
        },

        dateAsString (value) {
            return Core.format.date.display(value);
        },
    }
}
</script>

<style scoped>

</style>